
import { Contents, ContentsDocument } from '@platyplus/rxdb-hasura'
import { toObserver, useSubscription } from '@vueuse/rxjs'
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  toRefs
} from 'vue'

import { useDB, useFormProperty, useProperty } from '../../../composables'

export default defineComponent({
  name: 'FieldEditCollection',
  props: {
    document: {
      type: Object as PropType<ContentsDocument>,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { name, document } = toRefs(props)
    const { model } = useFormProperty<string[] | undefined>(document, name)
    const db = useDB()
    const property = useProperty(document, name)
    // * filter out removed references
    const filteredModel = computed<string[]>({
      get: () =>
        model.value?.filter(id =>
          options.value.find(option => option.id === id)
        ) || [],
      set: (val: string[]) => {
        model.value = val
      }
    })
    // TODO move to a new useOptions(document, propertyName) ?
    const options = ref<Array<Contents>>([])
    const optionDocument = (id: string) =>
      options.value.find(option => option.id === id)

    const remove = (id: string) =>
      (model.value = model.value?.filter(curs => curs !== id))
    // ? Really necessary to pass through 'onMounted'?
    onMounted(() => {
      const refCollection = db.value?.[property.value.ref as string]
      refCollection &&
        useSubscription(
          refCollection.find().sort('label').$.subscribe(toObserver(options))
        )
    })
    return { filteredModel, options, optionDocument, remove }
  }
})
